import React from "react";
import Modal from "react-modal";
import "../css/PointerraModal.css";

function PointerraModal({ isOpen, onClose, bookmarkUrl, defectId }) {
    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={onClose}
            contentLabel="3D Model Viewer"
            className="pointerra-modal-content"
            overlayClassName="pointerra-modal-overlay"
        >
            <div className="pointerra-modal-header">
                <span className="pointerra-modal-title">
                    3D Model{defectId ? ` — ${defectId}` : ""}
                </span>
                <button
                    type="button"
                    className="pointerra-modal-close"
                    onClick={onClose}
                    aria-label="Close 3D view"
                >
                    ×
                </button>
            </div>
            <div className="pointerra-modal-body">
                {bookmarkUrl ? (
                    <iframe
                        title="Pointerra 3D View"
                        src={bookmarkUrl}
                        allow="fullscreen"
                        className="pointerra-modal-iframe"
                    />
                ) : (
                    <div className="pointerra-modal-empty">
                        No 3D view available for this defect.
                    </div>
                )}
            </div>
        </Modal>
    );
}

export default PointerraModal;
